import { StoredBoat } from '@components/CompareBoats/hooks/useCompare';
import { TheBoatDBConfigType, useConfig } from '@marine/configs';
import styles from '@styles/SingleBoat/Compare/compare_boat_card.module.scss';
import { getBoatName } from '@utils/getBoatName';
import { Button, Divider, Grid } from 'antd';
import { X } from 'lucide-react';
import React, { useMemo } from 'react';
import { SanityImage } from 'sanity-image';
import BoatImagePlaceholder from '../../../../../packages/sailor-assets/svg/no-image-placeholder.svg';

type Props = {
  boat: StoredBoat;
  removeBoat: (boat: StoredBoat) => void;
};

const CompareBoatCard: React.FC<Props> = ({ boat, removeBoat }) => {
  const boatTitle = useMemo(() => getBoatName(boat?.attributes), [boat?.attributes]);
  const { projectId, dataset } = useConfig<TheBoatDBConfigType>();
  const imageRef = boat.attributes.image?.asset?._ref;

  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();

  // const stats = [
  //   {
  //     icon: <EyeFilled />,
  //     count: total_views,
  //   },
  //   {
  //     icon: <HeartFilled />,
  //     count: favorites_count,
  //   },
  // ];

  const removeFromCompare = () => {
    removeBoat(boat);
  };

  return (
    <div className={styles.container}>
      <div className={styles.container__card}>
        <div className={styles.card__image}>
          {imageRef ? (
            <SanityImage
              projectId={projectId}
              dataset={dataset}
              id={imageRef}
              width={170}
              height={95}
              alt={`${boatTitle}`}
            />
          ) : (
            <BoatImagePlaceholder />
          )}
        </div>

        <div className={styles.card__content}>
          <div className={styles.main__content}>
            <h3 className={styles.card__title}>{boatTitle}</h3>

            <ul className={styles.card__stats}>
              {/* TODO for view counts and favorite */}
              {/* {stats.map((item) => {
                const { icon, count } = item;

                return (
                  <li className={styles.stats__item} key={item?.icon?.key}>
                    {icon} <p>{count}</p>
                  </li>
                );
              })} */}
            </ul>
          </div>

          {xs && <Divider style={{ margin: '8px 0', marginBottom: 4 }} />}

          {xs ? (
            <Button type="link" onClick={() => removeFromCompare()}>
              Remove
            </Button>
          ) : (
            <Button type="text" icon={<X size={16} />} onClick={() => removeFromCompare()} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CompareBoatCard;
